import { get } from "app/utils/axios/kheti";
import { SubScribedCrops } from "../models/crop";
import { getCookieValue } from "app/farmer360/utils/helper";

const fetchSubscribedCorps = async () => {
  const userAuthId = getCookieValue("userAuthId");
  return await get<SubScribedCrops[]>("/advisory/v1/plan/1/subscriptions", {
    ...(userAuthId ? { farmer: userAuthId } : {}),
  });
};

export default fetchSubscribedCorps;
